import React, { useContext, useEffect } from 'react'
import AppTable from '../table/AppTable'
import { useMutation, useQuery } from '@apollo/client';
import { GET_LOGITIX_AUDIT_LOGS } from '../../../features/AuditLogs/api/AuditLogQuery';
import ToasterWithMessage from '../toaster';
import styles from '../error-dashboard/AddTicketsError.module.css';
import { CircularProgress } from '@mui/material';


const AuditLogitixLogs = (props: any) => {
    const {
          rowsPerPage,
          currentPage,
          setCurrentPage,
          checking,
          setChecking,
          auditLogsList,
          setAuditLogsList,
          columnTypes,
          setColumnTypes,
          sortType,
          setSortType,
          selected,
          setSelected,
          GenerateAuditLogsHeadCells,
          handleChangeRowsPerPage,
          handlePageChange
    } = props;

    const {error} = ToasterWithMessage();

    const {
            data:getAllAuditLogsData,
            loading: getAllAuditLogsLoading,
            error: getAllAuditLogsError,
            refetch: refetchAuditLogs
         } = useQuery(GET_LOGITIX_AUDIT_LOGS, {
            fetchPolicy: 'no-cache',
            onCompleted: (data) => {       
                setAuditLogsList(data);
            },
            onError: (err) => {
                console.log(err)
            }
        })

  return (
    <>
    {
        getAllAuditLogsLoading
    ?
        <div className={styles.TableCircularProgress}>
        <CircularProgress color="primary" size={35} />
        </div>
    :
    <AppTable
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handlePageChange={handlePageChange}
        setColumnTypes={setColumnTypes}
        sortType={sortType}
        setSortType={setSortType}
        setChecking={setChecking}
        checking={checking}
        rowsPerPage={rowsPerPage}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        list={auditLogsList}
        tableTitle="auditLogitixLogs"
        selected={selected}
        setSelected={setSelected}
        generateHeadCells={GenerateAuditLogsHeadCells}
    />
    }
    </>
  )
}

export default AuditLogitixLogs